import {BasicLayout, PageLayout, TabLayout} from '@/components/layouts'


/**
 * 走菜单，走权限控制
 */
export const asyncRouterMap = [
    {
        path: '/main',
        name: 'Main',
        component: TabLayout,
        meta: { title: '首页' },
        redirect: '/main/analysis',
        children: [
            /*{
                path: '/main/analysis',
                name: 'Analysis',
                component: () => import('@/views/main/Analysis'),
                meta: { title: '分析页', permission: [ 'main' ] }
            }*/
        ]
    },
    {
        path: '/web',
        name: 'Web',
        component: PageLayout,
        meta: { title: '首页' },
        redirect: '/web/index',
        children: [

        ]
    },
    {
        path: '*', redirect: '/404', hidden: true
    }
];

/**
 * 基础路由
 */
export const constantRouterMap = [
    {
        path: '/user',
        name: 'User',
        component: BasicLayout,
        meta: { title: '用户' },
        redirect: '/user/login',
        children: [
            {
                path: 'login',
                name: 'Login',
                component: () => import('@/views/user/Login')
            },
            {
                path: 'register',
                name: 'Register',
                component: () => import('@/views/user/Register')
            },
            {
                path: 'retrievePassword',
                name: 'RetrievePassword',
                component: () => import('@/views/user/RetrievePassword')
            },
            {
                path: 'resetPassword',
                name: 'ResetPassword',
                component: () => import('@/views/user/ResetPassword')
            }
        ]
    },
    {
        path: '/web',
        name: 'Web',
        component: PageLayout,
        meta: { title: '首页' },
        redirect: '/web/index',
        children: [
            {
                path: '/web/index',
                name: 'WebIndex',
                component: () => import('@/views/web/Index')
            },
            {
                path: '/web/mi/index',
                name: 'MiIndex',
                component: () => import('@/views/web/mi/Index')
            },
        ]
    },
 ];

